import {
    useContext,
} from "react";

import PlatformAuthContext
    from "../components/ContextApi/PlatformAuthContext";


const usePlatformAuth =
    () => {

        const context =
            useContext(
                PlatformAuthContext
            );


        if (
            !context
        ) {

            throw new Error(
                "usePlatformAuth must be used inside PlatformAuthProvider"
            );

        }


        return context;

    };


export default usePlatformAuth;